import { useBreadcrumbsStore } from "entities/breadcrumbs";
import { useEffect } from "react";
import { Calendar } from "widgets/calendar";

export const CalendarPage = () => {
  const setCrumbs = useBreadcrumbsStore((s) => s.setCrumbs);
  
  useEffect(() => {
    setCrumbs([
      { title: "Моя пасека", url: "/", route: { path: "/" } },
      { title: "Календарь", url: "/calendar", route: { path: "/calendar" } },
    ]);
  }, []);

  return <Calendar />
}